const serverName = process.env.REACT_APP_SERVER_NAME || "test"

const gitCommit = process.env.REACT_APP_GIT_COMMIT || "unknown"

const config = {
    production: {
        // 同源相对地址：本机（starship.shadowearth.cn）只有 https，写死 http:// 会被浏览器
        // 按「混合内容」拦掉——登录框、所有 api.get 一起哑掉（2026-10-05 真机实测）。
        // nginx 一直把页面和 /v1 放在同一台机器上，相对地址与原来的绝对地址等价。
        apiUrl: '/v1/',
        debugMode: false,
    },
    development: {
        apiUrl: 'http://localhost:8070/v1/',
        debugMode: true,
    },
    test: {
        apiUrl: `http://${ serverName }.shadowearth.cn/v1/`,
        debugMode: true,
    },
    version: {
        commit: gitCommit,
        server: serverName,
    },
}

export default config
